<template>
  <div class="shopCardList">
    <div style="margin: 0;width: 100%;height: 100%">
      <div style="position: relative">
<!--        <div v-if="!row.totalStock || row.totalStock < 0" class="centerBox" style=" position: absolute; top: 0; bottom: 0;width: 100%;background-color: rgba(255, 255 ,255 , .5); z-index: 10">-->
<!--          <img src="../../assets/img/wuhuo1.png" style="width: 50%; opacity: .9;">-->
<!--        </div>-->
        <div @click="toInfo(row.id)" style="background-color: #ffffff; display: flex; position: relative">
          <img :src="row.goodsImg" style="width: 100%; height: 100%" >
        </div>
      </div>
      <div class="shopCardInfo" style="display: inline-block; background-color: white; width: 100%">
        <div class="goodsFlagShopName" style="width: 40vw">
          {{row.goodsName}}
<!--            精品红油-->
        </div>
        <div style="justify-content: left;margin: 1vw 0;color: #9f9f9f;font-size: 2.67vw">
          {{row.specification || ''}}
        </div>
          <div style="justify-content: left;margin: 0;color: #9f9f9f;font-size: 2.67vw">
              单价: {{row.unitPrice / 100 || 0}}
          </div>
        <div class="shopTag primaryText2" style="justify-content: left;margin: 1.17vw 0 1.07vw;color: #da3939">
<!--            {{row.goodsDesc}}-->
            数量: {{row.buyQty}}
        </div>
        <div class="shopCardMoney" style="margin-bottom: 1.07vw;">
          <div style="">
            <span style="font-size: 3.73vw;letter-spacing: -.5vw;">￥</span><span style="font-size: 7.2vw;font-weight: 600">{{$utils.priceFormat(row.price)}}</span>
          </div>
        </div>
      </div>
    </div>
<!--    <div @click.stop="expend(row)" style="position: absolute;top: 55vw;right: 2.9vw;width: 4vw;height: 4vw">-->
<!--      <van-icon v-show="!row.show" color="#666" style="font-size: 4vw" name="arrow-down" />-->
<!--      <van-icon v-show="row.show" color="#666" style="font-size: 4vw" name="arrow-up" />-->
<!--    </div>-->
    <div style="position: relative">
      <div @click.stop @click="changeShop(row)"
           v-if="isActive"
           style="position: absolute;bottom: 1.07vw;right: 1.87vw;">
  <!--      <img src="../../assets/img/addCardButton.png" style="width: 6.13vw">-->
      </div>
      <div class="addButton" @click.stop @click="changeShop(row)"
             v-else>
          <img :src="icon.addButton" style="width: 3.73vw">
      </div>
    </div>
    <div style="width: 100%;background-color: white">
<!--      分类附属品-->
      <span v-if="row.minGoodsList && row.minGoodsList[0] !== null && row.show" style="font-weight: 700;font-size: 3.9vw;margin-left: 2vw">关联商品</span>
      <div v-if="row.minGoodsList && row.minGoodsList[0] !== null && row.show">
        <div v-for="item in row.minGoodsList" :key="item.id" style="width: 100%;height: 9vw;position: relative;margin: 2vw 0 0;">
          <span style="width: 8vw;height: 8vw;display: inline-block;position: absolute;top: 0vw;">
            <img v-if="item.goodsImg || item.imgPath" :src="item.goodsImg || item.imgPath" style="width: 100%;height: 100%">
          </span>
          <span style="font-weight: 700;font-size: 3vw;top:0;left: 10vw;position: absolute;width: 20vw;overflow: hidden;display: inline-block;height: 4vw">{{item.goodsName}}</span>
          <span style="font-weight: 700;font-size: 3vw;position: absolute;left: 10vw;top:4.5vw;position: absolute">￥{{item.price/100}}</span>
          <div style="position: absolute; right: 2.6vw;bottom: 3vw;" class="shopListStepper">
            <van-stepper
              v-model="item.buyQty"
              input-width="6.67vw"
              button-size="3.73vw"
              integer
              v-if="item.buyQty"
              disable-input
              @plus="changePlusTwo(item, row)"
              @minus="changMinusTwo(item, row)"
              :min="0">
            </van-stepper>
            <div style="position: absolute;bottom: 2.1vw;right: 0vw;width: 4vw;height: 4vw" v-else @click.stop @click="changePlusTwo(item, row)">
              <img :src="icon.addButton" style="width: 3.73vw">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addButton from '../../assets/img/icon/addButton.png'
export default {
  name: 'index',
  props: {
    row: Object,
    isActive: Boolean
  },
  data () {
    return {
      icon: {
        addButton
      }
    }
  },
  methods: {
    toInfo (id) {
      this.$emit('toInfo', id)
    },
    changeShop (item) {
      this.$emit('changeShop', item)
    },
    expend (item) {
      this.$emit('expend', item)
    },
    changePlusTwo (item, row) {
      this.$emit('plusTwo', item, row)
    },
    changMinusTwo (item, row) {
      this.$emit('minusTwo', item, row)
    }
  }
}
</script>

<style>
</style>
